import React from 'react';

import { Button } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import ModalDialog from '../../../../Shared/ModalDialog';

interface InProgressJobModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const InProgressJobModal: React.FC<InProgressJobModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <ModalDialog
      isOpen={isOpen}
      onRequestClose={onClose}
      subHeaderText={
        <>
          <div className="mb-10 text-2xl">
            You already have a generation in progress.
          </div>
          <div>
            You can't edit another video until your current generation
            completes. You can refresh your page to see the generation that's in
            progress.
          </div>
        </>
      }
      className="max-w-xl p-8"
      topOffsetClass="top-1/2 transform -translate-y-1/2"
      subHeaderTextClassName="text-base text-gray-900"
      contentLabelContainerClassName="space-y-0"
      closeButtonClassName="text-gray-700 font-light"
    >
      <div className="flex gap-3 justify-end">
        <Button onClick={onClose}>Refresh my Page</Button>
      </div>
    </ModalDialog>
  );
};

export default InProgressJobModal;
